import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
// Значения расположены в порядке приоритета
export var DIRECTIONS = {
  topLeft: 'topLeft',
  top: 'top',
  topRight: 'topRight',
  rightTop: 'rightTop',
  right: 'right',
  rightBottom: 'rightBottom',
  bottomLeft: 'bottomLeft',
  bottom: 'bottom',
  bottomRight: 'bottomRight',
  leftBottom: 'leftBottom',
  left: 'left',
  leftTop: 'leftTop'
};
export var defaultPossibleDirections = Object.keys(DIRECTIONS);

var getPosition = function getPosition() {
  var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return {
    x: Math.round(x),
    y: Math.round(y)
  };
};

export var getComputedPositionAndDirection = function getComputedPositionAndDirection(_ref) {
  var _anchorRef$current, _ref3;

  var anchorRef = _ref.anchorRef,
      contentNode = _ref.contentNode,
      offset = _ref.offset,
      arrowOffset = _ref.arrowOffset;

  var _ref2 = anchorRef === null || anchorRef === void 0 ? void 0 : (_anchorRef$current = anchorRef.current) === null || _anchorRef$current === void 0 ? void 0 : _anchorRef$current.getBoundingClientRect(),
      anchorWidth = _ref2.width,
      anchorHeight = _ref2.height,
      x = _ref2.left,
      y = _ref2.top;

  var contentHeight = 0;
  var contentWidth = 0;

  if (contentNode) {
    var _contentNode$getBound = contentNode === null || contentNode === void 0 ? void 0 : contentNode.getBoundingClientRect(),
        height = _contentNode$getBound.height,
        width = _contentNode$getBound.width;

    contentHeight = height;
    contentWidth = width;
  }

  var anchorCenter = {
    x: x + anchorWidth / 2,
    y: y + anchorHeight / 2
  };
  var documentHeight = document.documentElement.clientHeight;
  var xForRightDirections = x + anchorWidth + offset;
  var xForLeftDirections = x - contentWidth - offset;
  var horizontalDirection = {
    right: x + anchorWidth - contentWidth + arrowOffset,
    center: anchorCenter.x - contentWidth / 2,
    left: x - arrowOffset
  };
  var yForDownDirections = y + anchorHeight + offset;
  var yForUpDirections = documentHeight - y + offset;
  var verticalDirection = {
    top: y - arrowOffset,
    center: anchorCenter.y - contentHeight / 2,
    bottom: y + anchorHeight - contentHeight + arrowOffset
  };
  return _ref3 = {}, _defineProperty(_ref3, DIRECTIONS.top, getPosition(horizontalDirection.center, yForUpDirections)), _defineProperty(_ref3, DIRECTIONS.topLeft, getPosition(horizontalDirection.left, yForUpDirections)), _defineProperty(_ref3, DIRECTIONS.topRight, getPosition(horizontalDirection.right, yForUpDirections)), _defineProperty(_ref3, DIRECTIONS.bottom, getPosition(horizontalDirection.center, yForDownDirections)), _defineProperty(_ref3, DIRECTIONS.bottomLeft, getPosition(horizontalDirection.left, yForDownDirections)), _defineProperty(_ref3, DIRECTIONS.bottomRight, getPosition(horizontalDirection.right, yForDownDirections)), _defineProperty(_ref3, DIRECTIONS.right, getPosition(xForRightDirections, verticalDirection.center)), _defineProperty(_ref3, DIRECTIONS.rightTop, getPosition(xForRightDirections, verticalDirection.top)), _defineProperty(_ref3, DIRECTIONS.rightBottom, getPosition(xForRightDirections, verticalDirection.bottom)), _defineProperty(_ref3, DIRECTIONS.left, getPosition(xForLeftDirections, verticalDirection.center)), _defineProperty(_ref3, DIRECTIONS.leftTop, getPosition(xForLeftDirections, verticalDirection.top)), _defineProperty(_ref3, DIRECTIONS.leftBottom, getPosition(xForLeftDirections, verticalDirection.bottom)), _ref3;
};
export var getPossibleDirection = function getPossibleDirection(currentDirection, directionsAndPositions, possibleDirections, contentNode) {
  // Указанное направление переносим в начало списка,
  // затем исключаем все позиции, которые не указаны в доступных
  var directionKeys = defaultPossibleDirections.reduce(function (acc, direction) {
    if (currentDirection === direction) {
      return [direction].concat(_toConsumableArray(acc));
    }

    return [].concat(_toConsumableArray(acc), [direction]);
  }, []).filter(function (direction) {
    return possibleDirections.includes(direction);
  });
  var _document$documentEle = document.documentElement,
      clientHeight = _document$documentEle.clientHeight,
      clientWidth = _document$documentEle.clientWidth;
  var contentHeight = 0;
  var contentWidth = 0;

  if (contentNode) {
    var _contentNode$getBound2 = contentNode.getBoundingClientRect(),
        height = _contentNode$getBound2.height,
        width = _contentNode$getBound2.width;

    contentHeight = height;
    contentWidth = width;
  } // Находим первую доступную позицию для отображения, либо используем указанную


  var direction = directionKeys.find(function (key) {
    var position = directionsAndPositions[key];
    var isFullVisibleLeft = position.x >= 0;
    var isFullVisibleRight = position.x + contentWidth <= clientWidth;
    var isFullVisibleTop = position.y >= 0;
    var isFullVisibleDown = position.y + contentHeight <= clientHeight;
    return isFullVisibleLeft && isFullVisibleRight && isFullVisibleTop && isFullVisibleDown;
  }) || currentDirection;
  return {
    direction: direction,
    position: directionsAndPositions[direction]
  };
};